import { render, staticRenderFns } from "./bulma_sections.vue?vue&type=template&id=3fcc7a41&scoped=true&lang=html"
import script from "./bulma_sections.vue?vue&type=script&lang=js"
export * from "./bulma_sections.vue?vue&type=script&lang=js"
import style0 from "./bulma_sections.vue?vue&type=style&index=0&id=3fcc7a41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc7a41",
  null
  
)

export default component.exports